export const LOCATION = 'location'
export const LOCATION_SUCCESS = 'location_success'
export const LOCATION_FAIL = 'location_fail'

export const FORECAST = 'forecast'
export const FORECAST_SUCCESS = 'forecast_success'
export const FORECAST_FAIL = 'forecast_fail'